import React, { useState } from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 400px;
  @media (max-width: 800px) {
    padding: 37px 0px;
  }
`;

const RunsList = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  padding-bottom: 24px;
  padding-right: 16px;
  margin-right: -16px;
`;

const RunItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7px 0px;
  background: rgba(255, 255, 255, 0.1);
  cursor: pointer;
  min-width: 0;
`;

const RunName = styled.div`
  font-size: 14px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 8px;
`;

const RunCount = styled.div`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.3);
  flex-shrink: 0;
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
`;

const ToggleButton = styled.button`
  background: none;
  border: none;
  padding: 0px;
  font-size: 12px;
  cursor: pointer;
  color: #0077ff;
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  justify-content: right;
  margin-top: -20px;
  margin-bottom: 8px;

  &:hover {
    color: #005fcc;
  }
`;

export default function TopSkiedRunsChart({ resortRuns, onHoverLocation }) {
  const [showNeverCompleted, setShowNeverCompleted] = useState(false);

  if (!resortRuns || !Array.isArray(resortRuns)) {
    return null;
  }

  const handleMostSkiedRunHover = (isHovering, coordinates) => {
    if (isHovering) {
      const [lng, lat] = coordinates;
      onHoverLocation({ lng, lat });
    } else {
      onHoverLocation(null);
    }
  };

  // Sort runs based on the current view
  const sortedRuns = [...resortRuns]
    .filter((run) =>
      showNeverCompleted ? run.completions === 0 : run.completions > 0
    )
    .sort((a, b) => {
      if (showNeverCompleted) {
        // Define type order for sorting
        const typeOrder = {
          lift: 0,
          green: 1,
          blue: 2,
          orange: 3,
          black: 4,
        };

        // First sort by type
        const typeA = a.type === "lift" ? "lift" : a.difficulty;
        const typeB = b.type === "lift" ? "lift" : b.difficulty;
        const typeDiff = typeOrder[typeA] - typeOrder[typeB];

        // If same type, sort alphabetically
        return typeDiff !== 0 ? typeDiff : a.name.localeCompare(b.name);
      } else {
        // Sort completed runs by completion count
        return b.completions - a.completions;
      }
    });

  return (
    <Container>
      <ToggleButton onClick={() => setShowNeverCompleted(!showNeverCompleted)}>
        {showNeverCompleted ? "Show completed" : "Show never done"}
      </ToggleButton>
      <RunsList>
        {sortedRuns.map((run, index) => (
          <RunItem
            key={index}
            onMouseEnter={() => handleMostSkiedRunHover(true, run.coordinates)}
            onMouseLeave={() => handleMostSkiedRunHover(false)}
          >
            <RunName>
              {run.name}{" "}
              {run.type === "lift" ? (
                "🚡"
              ) : run.difficulty === "green" ? (
                <span style={{ color: "#4CAF50" }}>●</span>
              ) : run.difficulty === "blue" ? (
                <span style={{ color: "#2196F3" }}>■</span>
              ) : run.difficulty === "black" ? (
                <span style={{ color: "#000000" }}>◆</span>
              ) : run.difficulty === "orange" ? (
                <span style={{ color: "#FF9800" }}>⬮</span>
              ) : null}
            </RunName>
            <RunCount>{run.completions}x</RunCount>
          </RunItem>
        ))}
      </RunsList>
    </Container>
  );
}
